const links = document.querySelectorAll('#column-left a');
const filterButtons = document.querySelectorAll('#subnavigation button');
const roleSections = document.querySelectorAll('.role');

setActiveBasedOnHash(window.location.hash);

window.addEventListener('hashchange', () => {
	const { hash } = window.location;
	setActiveBasedOnHash(hash);
});

filterButtons.forEach(button => {
	button.addEventListener('click', () => {
		setFilter(button.dataset.filter, button.dataset.role);
	});
});

function setActiveBasedOnHash(hash) {
	if (hash) {
		const link = document.querySelector(`[href="${hash}"]`);

		if (link) {
			links.forEach(link => link.classList.remove('active'));
			link.classList.add('active');
		}
	} else {
		links.forEach(link => link.classList.remove('active'));
	}
}

function setFilter(filter, value) {
	if (value === '$all') {
		roleSections.forEach(el => el.classList.remove('hidden'));
	} else {
		roleSections.forEach((el) => {
			const role = el.dataset.role;
			if (role === value) {
				el.classList.remove('hidden');
			} else {
				el.classList.add('hidden');
			}
		});
	}

	filterButtons.forEach((el) => {
		const role = el.dataset.role;
		if (role === value) {
			el.classList.add('active');
		} else {
			el.classList.remove('active');
		}
	});

	const displayValue = document.querySelector(`[data-filter="${filter}"][data-${filter}="${value}"]`).innerText;
	document.querySelector(`.current[data-filter="${filter}"]`).innerText = displayValue;

	window.location.hash = '';
	setActiveBasedOnHash(window.location.hash);
}
